export default "__VITE_ASSET__qV5gLFs7__"